import { render } from "./PatientInfoSheet.vue?vue&type=template&id=7849c140&scoped=true"
import script from "./PatientInfoSheet.vue?vue&type=script&lang=ts"
export * from "./PatientInfoSheet.vue?vue&type=script&lang=ts"

import "./PatientInfoSheet.vue?vue&type=style&index=0&id=7849c140&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-7849c140"

export default script